import React, { PureComponent } from 'react'
import cx from 'classnames'
import { uniqueId } from 'lodash'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import styles from './Loader.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default class Loader extends PureComponent {
  constructor(props) {
    super(props)

    this.uniqueId = uniqueId('loader-')
  }

  componentDidMount() {
    if (this.props.blocking) {
      const el = document.querySelector(`#${this.uniqueId}`)

      if (el) {
        disableBodyScroll(el)
      }
    }
  }

  componentWillUnmount() {
    if (this.props.blocking) {
      const el = document.querySelector(`#${this.uniqueId}`)

      if (el) {
        enableBodyScroll(el)
      }
    }
  }

  render() {
    const { className, floating, delayed, blocking } = this.props

    const classes = cx({
      [styles.floatingLoadingContainer]: floating,
      [styles.loadingContainer]: !floating,
      [styles.delayed]: delayed,
      [className]: className
    })

    return (
      <div className={classes} id={this.uniqueId}>
        {blocking && <div className={styles.overlay} />}
        <FontAwesomeIcon icon={['fal', 'spinner']} pulse size="2x"/>
      </div>
    )
  }
}
